import axios from 'axios';

console.log(console.log(window.miminApi)); // eslint-disable-line no-console
const apiBadWord = axios.create({
  baseURL: window.miminApi,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Function to set Authorization token
function setAuthToken(token) {
  apiBadWord.defaults.headers.common.Authorization = `Bearer ${token}`;
}

// Function to authenticate only if no token is stored
async function authenticateIfNeeded(credentials) {
  const response = await apiBadWord.post('/auth/auth-bad-wording', credentials);
  const token = response.data.token;
  setAuthToken(token);
}

// Interceptor untuk log request sebelum dikirim
apiBadWord.interceptors.request.use(
  config => {
    console.log(`Requesting: ${config.baseURL}${config.url}`, config); // eslint-disable-line no-console
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default {
  authenticateIfNeeded, // Call this only once when entering the page

  getAll(params = {}) {
    return apiBadWord.get('/bad-wording/get-all', { params });
  },

  create(data) {
    return apiBadWord.post('/bad-wording/create', data);
  },

  update(id, data) {
    return apiBadWord.put(`/bad-wording/update/${id}`, data);
  },

  delete(id) {
    return apiBadWord.put(`/bad-wording/delete/${id}`);
  },
};
